import type { NavigationComponentProps } from '@carvana/merch-tile';
import Link from 'next/link';

export default function NavigationLink({
  children,
  'data-adobe-id': dataAdobeId,
  'data-analytics-id': dataAnalyticsId,
  'data-testid': dataTestId,
  href,
  onClick,
  ...props
}: NavigationComponentProps) {
  return (
    <Link
      {...props}
      data-adobe-id={dataAdobeId}
      data-analytics-id={dataAnalyticsId}
      data-testid={dataTestId}
      href={href!}
      prefetch={false}
      onClick={onClick}
    >
      {children}
    </Link>
  );
}
